import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const POReportViewModule = new Module({
  id: 'PO-REPORT:VIEW:*',
  name: 'PO Report',
  label: 'PO Report',
  path: 'po-report',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/POReport'))
  ),
  actions: {
    viewDetails: {
      id: 'PO-REPORT:VIEW:DETAILS',
      name: 'view-details',
      label: 'View Details'
    }
  }
});

const POReportModules = [POReportViewModule];

export default new ModuleBundle('POReport', POReportModules);
